import React from 'react';
import { TTableHeaderControlButtonProps } from "types/Components/Common/Table/Table"

const TableHeaderControlButton = ({disableHeaderControls, setHeaderControlOpen}: TTableHeaderControlButtonProps) => {
    if(disableHeaderControls) return null

    return (
        <button 
            type="button" 
            className={`tw-aspect-sqaure tw-h-8 tw-w-8 tw-rounded hover:tw-bg-[#C5C6CC] focus:tw-outline-none`} 
            onClick={() => setHeaderControlOpen(true)}
            >
                <i className={`fa fa-bars tw-text-gray-dark`}/>
        </button>
    )
}

export default TableHeaderControlButton